import { render } from "./VirtualMailboxesSettings.vue?vue&type=template&id=6f71fb6c"
import script from "./VirtualMailboxesSettings.vue?vue&type=script&lang=ts"
export * from "./VirtualMailboxesSettings.vue?vue&type=script&lang=ts"
script.render = render

export default script